/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_State_Select_ValidationInputs */



/**
* | output |
* | --- |
* | "Please select a new state." |
*
* @param {Explorer_Info_State_Select_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_state_select_validation = /** @type {((inputs?: Explorer_Info_State_Select_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_State_Select_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner un nouvel etat.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie einen neuen Bundesstaat.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un nuovo stato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите новый штат.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un nuevo estado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择一个新的州。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい州を選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया एक नया राज्य चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, selecione um novo estado.")
	return /** @type {LocalizedString} */ ("Please select a new state.")
});